import { WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Params } from '@angular/router';

export function restoreFromUrl(
	p: Params,
	state: {
		driverFilter: WritableSignal<string>;
		plnMin: WritableSignal<number | null>;
		plnMax: WritableSignal<number | null>;
		eurMin: WritableSignal<number | null>;
		eurMax: WritableSignal<number | null>;
		onlyWithEntries: WritableSignal<boolean>;
		currentPage: WritableSignal<number>;
		pageSize: WritableSignal<number>;
		sortBy: WritableSignal<string | null>;
		sortDirection: WritableSignal<'asc' | 'desc' | null>;
		driverFilterControl: FormControl<string | null>;
		plnMinControl: FormControl<number | null>;
		plnMaxControl: FormControl<number | null>;
		eurMinControl: FormControl<number | null>;
		eurMaxControl: FormControl<number | null>;
		onlyWithEntriesControl: FormControl<boolean | null>;
	},
): void {
	const driver = String(p['driver'] ?? '').trim();
	if (driver) {
		state.driverFilter.set(driver);
		state.driverFilterControl.setValue(driver, { emitEvent: false });
	}
	if (p['plnMin'] != null) {
		const v = Number(p['plnMin']);
		state.plnMin.set(v);
		state.plnMinControl.setValue(v, { emitEvent: false });
	}
	if (p['plnMax'] != null) {
		const v = Number(p['plnMax']);
		state.plnMax.set(v);
		state.plnMaxControl.setValue(v, { emitEvent: false });
	}
	if (p['eurMin'] != null) {
		const v = Number(p['eurMin']);
		state.eurMin.set(v);
		state.eurMinControl.setValue(v, { emitEvent: false });
	}
	if (p['eurMax'] != null) {
		const v = Number(p['eurMax']);
		state.eurMax.set(v);
		state.eurMaxControl.setValue(v, { emitEvent: false });
	}
	if (p['onlyWithEntries']) {
		state.onlyWithEntries.set(true);
		state.onlyWithEntriesControl.setValue(true, { emitEvent: false });
	}
	if (p['page']) state.currentPage.set(Number(p['page']));
	if (p['perPage']) state.pageSize.set(Number(p['perPage']));
	if (p['sortBy']) state.sortBy.set(p['sortBy']);
	if (p['sortDirection'] && (p['sortDirection'] === 'asc' || p['sortDirection'] === 'desc')) {
		state.sortDirection.set(p['sortDirection']);
	}
}
